module.exports = __webpack_public_path__ + "static/img/banner.fae0dc20.png";